<template>
  <div style="width: 100%">
    <EmptyTablePlaceholder
      v-if="type ? type === 'sales' : isSalesHubOnboardingActive"
      :icon="salesIcon || icon"
      :img="salesImg || img"
      :title="$t('onboarding.HerellBeYourData')"
      :button-text="$t('leads.AddLeads')"
      :description="salesDescription"
      :show-background="false"
      @buttonClick="$router.push('/admin/leads'); $emit('buttonClick')"
    />
    <EmptyTablePlaceholder
      v-else-if="type ? type === 'service' : isServiceHubOnboardingActive"
      :icon="serviceIcon || icon"
      :img="serviceImg || img"
      :title="serviceTitle || $t('onboarding.HerellBeYourData')"
      :button-text="$t('adminTitles.AddPolicy')"
      :description="serviceDescription"
      :show-background="false"
      @buttonClick="$router.push('/admin/policies'); $emit('buttonClick')"
    />
  </div>
</template>

<script>
import onboardingMixin from '@/mixins/onboardingMixin';
import EmptyTablePlaceholder from './EmptyTablePlaceholder';

export default {
  name: 'OnboardingEmptyPlaceholder',
  components: { EmptyTablePlaceholder },
  mixins: [onboardingMixin],
  props: {
    type: { type: String, default: '' },
    icon: { type: String, default: '' },
    img: { type: String, default: '' },
    salesIcon: { type: String, default: null },
    salesImg: { type: String, default: null },
    salesDescription: { type: String, default: '' },
    serviceIcon: { type: String, default: null },
    serviceImg: { type: String, default: null },
    serviceDescription: { type: String, default: '' },
    serviceTitle: { type: String, default: null },
  },
};
</script>
